import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserUtil } from 'src/app/data/utils/user.utils';

@Component({
  selector: 'app-gate-card',
  templateUrl: './gate-card.component.html',
  styleUrls: ['./gate-card.component.scss'],
})
export class GateCardComponent implements OnInit {
  @Input() gateName: string = '';
  @Input() gateid: string = '';

  @Output() monitoreClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() editClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() removeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  canEdit: boolean = false;

  constructor(private userUtil: UserUtil) {}

  ngOnInit(): void {
    this.canEdit = this.userUtil.canEditGates();
  }

  motitoreGate() {
    if (this.gateid !== '') {
      this.monitoreClicked.emit(this.gateid);
    }
  }

  editGate() {
    this.editClicked.emit(true);
  }

  removeGate() {
    this.removeClicked.emit(true);
  }
}
